import React from 'react';
import { connect } from 'react-redux';
import { authHeader, config } from '_helpers';
import { manifestActions } from '../_actions';
import moment from 'moment';
import '../assets/styles/manifest.css';
import { manifestService } from '_services';
import { formatDate } from '_helpers/helpers';
import { redirectToPdf } from '_helpers/redirectToPdf';
import { withRouter } from 'react-router-dom';
import { MANIFEST_TYPE } from './constants';
import { Dcrm } from './Manifest/DCRM';
import { Ifca } from './Manifest/IFCA';
import { Ncc } from './Manifest/NCC';
import { Vipr } from './Manifest/VIPR';
import { Project } from './Manifest/Project';
import PropTypes from 'prop-types';

const unDefined = 'undefined';

const RESOURCE_ORDER_FILE_TYPE = {
  CREATE_FORM: 1,
  UPLOADED_FORM: 2,
};

class ViewManifest extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isPrintManifestLoading: false,
      isViewRoLoading: false,
      added_date: null,
      crews: [],
      vehicles: [],
      manifestType: null,
      superintendent: [],
      crewOptions: [],
      vehicleOptions: [],
      statusOpen: false,
      form: {
        ordering_unit: '',
        incident_name: '',
        incident_number: '',
        resource_number: '',
        ifca_number: '',
        dispatch_location: '',
        project_name: '',
        project_code: '',
        report_to: '',
        des_place: '',
        des_eta: '',
        des_etd: '',
        inter_space: '',
        dep_place: '',
        dep_etd: '',
        dep_eta: '',
        vehicle_number: '',
        dispatch_time: '',
        perssonal: '',
        arr: '',
        dep_time: '',
        dep_arr: '',
        pdep_time: '',
        pedep_place: '',
        sign_auth_representative: '',
      },
      shighq: [],
      print: false,
      submit: false,
      manifest_list: false,
      crews_list: false,
      vehicles_list: false,
      saved_id: '',
      numPages: null,
      pageNumber: 1,
      ifca_incident: '',
    };
    this.printManifest = this.printManifest.bind(this);
    this.incidentChange = this.incidentChange.bind(this);
    this.onSelect = this.onSelect.bind(this);
  }

  incidentChange(e, type) {}

  onSelect(hash, e) {
    var value = e.target.value;
    this.state.shighq[hash] = value;
    this.setState({ shighq: this.state.shighq }, function () {
      if (this.state.manifestType === MANIFEST_TYPE.IFCA_Manifest) {
        this.generateIFCA();
      }
      if (
        this.state.manifestType === MANIFEST_TYPE.NCC ||
        this.state.manifestType === MANIFEST_TYPE.TYPE_2
      ) {
        this.generateNCC();
      }
      if (this.state.manifestType === MANIFEST_TYPE.VIPR) {
        this.generateVIPR();
      }
      if (this.state.manifestType === MANIFEST_TYPE.ODF) {
        this.generateODF();
      }
    });
  }

  printManifest() {
    this.setState({
      isPrintManifestLoading: true,
    });
    var data =
      '?manifest_id=' +
      this.props.manifest_id +
      '&resource_id=' +
      this.props.resource_id +
      '&manifest_version_id=' +
      this.props.manifest_version_id;
    // this.props.dispatch(manifestActions.printManifest(data));
    let fdata = new FormData();
    if (this.state.crews.length > 0) {
      this.state.crews.map((item, index) => {
        if (item.category === 'oncrew') {
          if (this.state.shighq[item.hash] !== undefined) {
            fdata.append('highq[' + index + ']', this.state.shighq[item.hash]);
          } else {
            fdata.append('highq[' + index + ']', item.highq);
          }
        }
        return fdata;
      });
    }
    const requestOptions = {
      method: 'POST',
      // method: 'GET',
      headers: authHeader(),
      body: fdata,
    };

    fetch(config.apiUrl + '/api/manifest/pdf' + data, requestOptions)
      .then((res) => res.json())
      .then((data) => {
        this.setState({ isPrintManifestLoading: false });
        redirectToPdf(data, 'manifest_' + Date.now());
      })
      .catch((error) => {
        // Handle any errors here if needed
        console.error('Error fetching PDF manifest:', error);
      });
  }

  formatPhoneNumber(s) {
    var s2 = ('' + s).replace(/\D/g, '');
    var m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
    return !m ? null : '(' + m[1] + ')-' + m[2] + '-' + m[3];
  }

  componentDidMount() {
    // Handle versionData if available on mount
    if (this.props.versionData) {
      this.loadVersionData(this.props.versionData);
      return;
    }

    // Fallback to old API calls if versionData is not provided (backward compatibility)
    var data = 'resource_id=' + this.props.resource_id;
    if (this.props.manifest_version_id) {
      data += '&manifest_version_id=' + this.props.manifest_version_id;
    }
    this.props.dispatch(manifestActions.getSuperintendent(data));

    let data2 = new FormData();
    data2.append('manifest_id', this.props.manifest_id);
    if (this.props.manifest_version_id) {
      data2.append('manifest_version_id', this.props.manifest_version_id);
    }
    this.props.dispatch(manifestActions.manifestDetails(data2));

    let data3 = new FormData();
    data3.append('resource_id', this.props.resource_id);
    data3.append('manifest_id', this.props.manifest_id);
    if (this.props.manifest_version_id) {
      data3.append('manifest_version_id', this.props.manifest_version_id);
    }
    data3.append('base_manifest_type', this.props.manifestType);
    this.props.dispatch(manifestActions.getUsers(data3));

    let data4 = new FormData();
    data4.append('resource_id', this.props.resource_id);
    data4.append('manifest_id', this.props.manifest_id);
    if (this.props.manifest_version_id) {
      data4.append('manifest_version_id', this.props.manifest_version_id);
    }
    this.props.dispatch(manifestActions.getVehicles(data4));
  }

  loadVersionData(versionData) {
    // Prepare state updates
    const stateUpdate = {
      isLoading: false,
    };

    // Set manifest form data
    if (versionData.manifest_data) {
      stateUpdate.form = versionData.manifest_data;
      stateUpdate.added_date =
        versionData.manifest_data.added_date || versionData.added_date;

      // Set effective dates for VIPR and other manifests
      if (versionData.manifest_data.eff_end_date) {
        stateUpdate['mend'] = moment(
          versionData.manifest_data.eff_end_date,
        ).format('MM/DD/YY');
      }
      if (versionData.manifest_data.eff_start_date) {
        stateUpdate['mstart'] = moment(
          versionData.manifest_data.eff_start_date,
        ).format('MM/DD/YY');
      }

      // Set resource order form if available
      if (versionData.resource_order_form) {
        stateUpdate.form = {
          ...stateUpdate.form,
          resource_order_form: versionData.resource_order_form,
        };
      }

      // Set manifest type from base_manifest_id (convert to string to match constants)
      if (versionData.manifest_data.base_manifest_id) {
        stateUpdate.manifestType = String(
          versionData.manifest_data.base_manifest_id,
        );
      }
    }

    // Set users/crew data
    if (versionData.users?.assigned) {
      stateUpdate.crews = versionData.users.assigned.map((user) => ({
        ...user,
        category: 'oncrew',
      }));
    }

    // Set vehicles data
    if (versionData.vehicles?.assigned) {
      stateUpdate.vehicles = versionData.vehicles.assigned.map((vehicle) => ({
        ...vehicle,
        category: 'selected',
      }));
    }

    // Set superintendent data
    if (versionData.superintendent) {
      stateUpdate.superintendent = Array.isArray(versionData.superintendent)
        ? versionData.superintendent[0]
        : versionData.superintendent;
    }

    // Set assignment history
    if (versionData.assignment_history) {
      stateUpdate.assignmentHistory = versionData.assignment_history;
    }

    // Set all state at once
    this.setState(stateUpdate, () => {
      // Generate manifest after state is set - this creates crewOptions and vehicleOptions
      const manifestType = this.state.manifestType;
      if (
        manifestType === MANIFEST_TYPE.IFCA_Manifest ||
        manifestType === MANIFEST_TYPE.ODF
      ) {
        this.generateIFCA();
      } else if (
        manifestType === MANIFEST_TYPE.NCC ||
        manifestType === MANIFEST_TYPE.TYPE_2
      ) {
        this.generateNCC();
      } else if (manifestType === MANIFEST_TYPE.VIPR) {
        this.generateVIPR();
      } else if (manifestType === MANIFEST_TYPE.DCRM) {
        this.generateDCRM();
      } else if (manifestType === MANIFEST_TYPE.PROJECT_MANIFEST) {
        this.generatePM();
      }
    });
  }

  componentWillMount() {
    // Legacy method - componentDidMount will handle versionData
    // Keep this for backward compatibility with old API calls
    if (!this.props.versionData) {
      var data = 'resource_id=' + this.props.resource_id;
      if (this.props.manifest_version_id) {
        data += '&manifest_version_id=' + this.props.manifest_version_id;
      }
      this.props.dispatch(manifestActions.getSuperintendent(data));

      let data2 = new FormData();
      data2.append('manifest_id', this.props.manifest_id);
      if (this.props.manifest_version_id) {
        data2.append('manifest_version_id', this.props.manifest_version_id);
      }
      this.props.dispatch(manifestActions.manifestDetails(data2));

      let data3 = new FormData();
      data3.append('resource_id', this.props.resource_id);
      data3.append('manifest_id', this.props.manifest_id);
      if (this.props.manifest_version_id) {
        data3.append('manifest_version_id', this.props.manifest_version_id);
      }
      data3.append('base_manifest_type', this.props.manifestType);
      this.props.dispatch(manifestActions.getUsers(data3));

      let data4 = new FormData();
      data4.append('resource_id', this.props.resource_id);
      data4.append('manifest_id', this.props.manifest_id);
      if (this.props.manifest_version_id) {
        data4.append('manifest_version_id', this.props.manifest_version_id);
      }
      this.props.dispatch(manifestActions.getVehicles(data4));
    }
  }

  handleViewResourceOrderForm() {
    this.setState({ isViewRoLoading: true });
    const rofType =
      this.state.form?.resource_order_form?.resource_order_form_type;
    switch (rofType) {
      case RESOURCE_ORDER_FILE_TYPE?.UPLOADED_FORM:
        window
          .open(this?.state?.form?.resource_order_form?.file_link, '_blank')
          .focus();
        this.setState({ isViewRoLoading: false });
        break;
      case RESOURCE_ORDER_FILE_TYPE?.CREATE_FORM:
        this?.printResourceOrderForm();
        break;
      default:
        break;
    }
  }

  printResourceOrderForm() {
    let data = new FormData();
    data.append('manifest_id', this.props.manifest_id);
    data.append('manifest_version_id', this.props.manifest_version_id);
    manifestService?.viewCreatedResourceOrderForm(data).then((response) => {
      this.setState({ isViewRoLoading: false });
      this?.redirectToPdf(response);
    });
  }

  redirectToPdf(data) {
    if (data?.success) {
      const pdfLink = data.data;
      var link = document.createElement('a');
      if (
        window.navigator.userAgent.match(/iPad/i) ||
        window.navigator.userAgent.match(/iPhone/i)
      ) {
        link.href = pdfLink;
      } else {
        link.href = pdfLink;
        link.target = '_blank';
      }
      document.body.appendChild(link);
      link.click();
      setTimeout(function () {
        document.body.removeChild(link);
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(pdfLink);
      }, 100);
    }
  }

  generateIFCA() {
    if (this.state.crews.length > 0) {
      var options = [],
        count = 0;
      this.state.crews.map((item, index) => {
        if (item.category === 'oncrew') {
          count++;
          options.push(
            <div className='middle_table tr' key={'ifca' + index}>
              <div
                className='td print_hash_value'
                data-header-title='Crew Member Name'
              >
                <p>
                  {count}. {item.first_name + ' ' + item.last_name}
                </p>
              </div>
              <div className='td print_center em_gender' data-header-title='M'>
                <p>{item.gender === 'Male' ? 'X' : ''}</p>
              </div>
              <div className='td print_center em_gender' data-header-title='F'>
                <p>{item.gender === 'Female' ? 'X' : ''}</p>
              </div>
              <div
                className='td print_center'
                data-header-title='Crew Member Number'
              >
                <p>{item.ica_number}</p>
              </div>
              <div
                className='td print_center'
                data-header-title='Incident Position'
              >
                <p>{item.incident_pos}</p>
              </div>
              <div
                className='td print_center Sawyer'
                data-header-title='Sawyer'
              >
                <p>{item.sawyer ? 'X' : ''}</p>
              </div>
              <div className='td print_center emt' data-header-title='EMT'>
                <p>{item.certified_emt === 'Yes' ? 'X' : ''}</p>
              </div>
              <div
                className='td print_center bry'
                data-header-title='Experience and Lsa (Blue-Red-Yellow)'
              >
                <p>{item.experience} </p>
              </div>
            </div>,
          );
        }
        return options;
      });
      if (count < 20) {
        for (var i = count; i < 20; i++) {
          count++;
          options.push(
            <div className='middle_table tr' key={'ifca' + i}>
              <div
                className='td print_hash_value'
                data-header-title='Crew Member Name'
              >
                <p>{count}. </p>
              </div>
              <div className='td print_center em_gender' data-header-title='M'>
                <p />
              </div>
              <div className='td print_center em_gender' data-header-title='F'>
                <p />
              </div>
              <div
                className='td print_center'
                data-header-title='Crew Member Number'
              >
                <p />
              </div>
              <div
                className='td print_center'
                data-header-title='Incident Position'
              ></div>
              <div
                className='td print_center Sawyer'
                data-header-title='Sawyer'
              >
                <p />
              </div>
              <div className='td print_center emt' data-header-title='EMT'>
                <p />
              </div>
              <div
                className='td print_center bry'
                data-header-title='Experience and Lsa (Blue-Red-Yellow)'
              >
                <p />
              </div>
            </div>,
          );
        }
      }
      this.setState({ crewOptions: options, isLoading: false });
    }

    if (this.state.vehicles.length > 0) {
      var optionsVeh = [];
      count = 0;
      this.state.vehicles.map((item, index) => {
        if (item.category === 'selected') {
          count++;
          optionsVeh.push(
            <div className='tr' key={index}>
              <div className='td' data-header-title='Driver Name'>
                <p>{item.first_name + ' ' + item.last_name}</p>
              </div>
              <div className='td' data-header-title='License Number/State'>
                <p>{item.drivers_license}</p>
              </div>
              <div className='td mdate' data-header-title='MSPA Exp. Date'>
                <p>{formatDate(item.mspa_exp_date)}</p>
              </div>
              <div className='td' data-header-title='Vehicle Make/Model'>
                <p>{item.vehicle_model_or_make}</p>
              </div>
              <div className='td' data-header-title='Vehicle License No.'>
                <p>
                  {item.vehicle_license === unDefined
                    ? ''
                    : item.vehicle_license}
                </p>
              </div>
            </div>,
          );
        }
        return optionsVeh;
      });
      if (count < 4) {
        for (i = count; i < 4; i++) {
          count++;
          optionsVeh.push(
            <div className='tr' key={'veh' + i}>
              <div className='td' data-header-title='Driver Name'>
                <p />
              </div>
              <div className='td' data-header-title='License Number/State'>
                <p />
              </div>
              <div className='td mdate' data-header-title='MSPA Exp. Date'>
                <p />
              </div>
              <div className='td' data-header-title='Vehicle Make/Model'>
                <p />
              </div>
              <div className='td' data-header-title='Vehicle License No.'>
                <p />
              </div>
            </div>,
          );
        }
      }
      this.setState({ vehicleOptions: optionsVeh });
    }
  }

  generateODF() {
    if (this.state.crews.length > 0) {
      var options = [],
        count = 0;
      this.state.crews.map((item, index) => {
        if (item.category === 'oncrew') {
          count++;
          options.push(
            <div className='middle_table tr' key={'ifca' + index}>
              <div
                className='td print_hash_value'
                data-header-title='Crew Member Name'
              >
                <p>
                  {count}. {item.first_name + ' ' + item.last_name}
                </p>
              </div>
              <div className='td print_center em_gender' data-header-title='M'>
                <p>{item.gender === 'Male' ? 'X' : ''}</p>
              </div>
              <div className='td print_center em_gender' data-header-title='F'>
                <p>{item.gender === 'Female' ? 'X' : ''}</p>
              </div>
              <div
                className='td print_center'
                data-header-title='Crew Member Number'
              >
                <p>{item.ica_number}</p>
              </div>
              <div
                className='td print_center'
                data-header-title='Incident Position'
              >
                <p>{item.incident_pos}</p>
              </div>
              <div
                className='td print_center Sawyer'
                data-header-title='Sawyer'
              >
                <p>{item.sawyer ? 'X' : ''}</p>
              </div>
              <div className='td print_center emt' data-header-title='EMT'>
                <p>{item.certified_emt === 'Yes' ? 'X' : ''}</p>
              </div>
              <div
                className='td print_center bry'
                data-header-title='Experience B-R-Y Blue-Red-Yellow'
              >
                <p>{item.experience} </p>
              </div>
            </div>,
          );
        }
        return options;
      });
      if (count < 20) {
        for (var i = count; i < 20; i++) {
          count++;
          options.push(
            <div className='middle_table tr' key={'ifca' + i}>
              <div
                className='td print_hash_value'
                data-header-title='Crew Member Name'
              >
                <p>{count}. </p>
              </div>
              <div className='td print_center em_gender' data-header-title='M'>
                <p />
              </div>
              <div className='td print_center em_gender' data-header-title='F'>
                <p />
              </div>
              <div
                className='td print_center'
                data-header-title='Crew Member Number'
              >
                <p />
              </div>
              <div
                className='td print_center'
                data-header-title='Incident Position'
              ></div>
              <div
                className='td print_center Sawyer'
                data-header-title='Sawyer'
              >
                <p />
              </div>
              <div className='td print_center emt' data-header-title='EMT'>
                <p />
              </div>
              <div
                className='td print_center bry'
                data-header-title='Experience B-R-Y Blue-Red-Yellow'
              >
                <p />
              </div>
            </div>,
          );
        }
      }
      this.setState({ crewOptions: options, isLoading: false });
    }

    if (this.state.vehicles.length > 0) {
      var optionsVeh = [];
      count = 0;
      this.state.vehicles.map((item, index) => {
        if (item.category === 'selected') {
          count++;
          optionsVeh.push(
            <div className='tr' key={index}>
              <div className='td' data-header-title='Driver Name'>
                <p>{item.first_name + ' ' + item.last_name}</p>
              </div>
              <div className='td' data-header-title='License Number/State'>
                <p>{item.drivers_license}</p>
              </div>
              <div className='td mdate' data-header-title='MSPA Exp. Date'>
                <p>{formatDate(item.mspa_exp_date)}</p>
              </div>
              <div className='td' data-header-title='Vehicle Make/Model'>
                <p>{item.vehicle_model_or_make}</p>
              </div>
              <div className='td' data-header-title='Vehicle License No.'>
                <p>
                  {item.vehicle_license === unDefined
                    ? ''
                    : item.vehicle_license}
                </p>
              </div>
            </div>,
          );
        }
        return optionsVeh;
      });
      if (count < 4) {
        for (i = count; i < 4; i++) {
          count++;
          optionsVeh.push(
            <div className='tr' key={'veh' + i}>
              <div className='td' data-header-title='Driver Name'>
                <p />
              </div>
              <div className='td' data-header-title='License Number/State'>
                <p />
              </div>
              <div className='td mdate' data-header-title='MSPA Exp. Date'>
                <p />
              </div>
              <div className='td' data-header-title='Vehicle Make/Model'>
                <p />
              </div>
              <div className='td' data-header-title='Vehicle License No.'>
                <p />
              </div>
            </div>,
          );
        }
      }
      this.setState({ vehicleOptions: optionsVeh });
    }
  }

  generateNCC() {
    if (this.state.crews.length > 0) {
      var options = [],
        count = 0;
      this.state.crews.map((item, index) => {
        if (item.category === 'oncrew') {
          count++;
          options.push(
            <div className='middle_table tr' key={'manifest' + index}>
              <div
                data-header-title='Employee Name (Last, First)'
                className='print_hash_value td ncc_emp_name'
              >
                <p className='num'>{count}</p>
                <p className='ename'>
                  {item.first_name + ' ' + item.last_name}
                </p>
              </div>
              <div className='print_center gender td' data-header-title='M'>
                <p>{item.gender === 'Male' ? 'X' : ''}</p>
              </div>
              <div className='print_center gender td' data-header-title='F'>
                <p>{item.gender === 'Female' ? 'X' : ''}</p>
              </div>
              <div
                className='print_center td identification'
                data-header-title='Identification Number'
              >
                <p>{item.fire_id}</p>
              </div>
              <div
                className='print_center td incidentPosition'
                data-header-title='Incident Position'
              >
                <p>{item.incident_pos}</p>
              </div>
              <div
                className='print_center td sawyer'
                data-header-title='Sawyer Class'
              >
                <p>{item.sawyer ? 'X' : ''}</p>
              </div>
              <div
                className='print_center td'
                data-header-title='Experience Blue-Red-Yellow (B_R_Y)'
              >
                <p>{item.experience ? item.experience.charAt(0) : ''}</p>
              </div>
            </div>,
          );
        }
        return options;
      });
      if (count < 20) {
        for (var i = count; i < 20; i++) {
          count++;
          options.push(
            <div className='tr' key={'manifest' + i}>
              <div
                data-header-title='Employee Name (Last, First)'
                className='print_hash_value td ncc_emp_name'
              >
                <p className='num'>{count}</p>
                <p className='ename' />
              </div>
              <div className='print_center gender td' data-header-title='M'>
                <p />
              </div>
              <div className='print_center gender td' data-header-title='F'>
                <p />
              </div>
              <div
                className='print_center td identification'
                data-header-title='Identification Number'
              >
                <p />
              </div>
              <div
                className='print_center td incidentPosition'
                data-header-title='Incident Position'
              >
                <p />
              </div>
              <div
                className='print_center td sawyer'
                data-header-title='Sawyer Class'
              >
                <p />
              </div>
              <div
                className='print_center td'
                data-header-title='Experience Blue-Red-Yellow (B_R_Y)'
              >
                <p />
              </div>
            </div>,
          );
        }
      }
      this.setState({ crewOptions: options, isLoading: false });
    }

    if (this.state.vehicles.length > 0) {
      var optionsVeh = [];
      count = 0;
      this.state.vehicles.map((item, index) => {
        if (item.category === 'selected') {
          count++;
          optionsVeh.push(
            <div className='tr' key={'vehicle' + index}>
              <div className='td' data-header-title='Driver Name'>
                <p>{item.first_name + ' ' + item.last_name}</p>
              </div>
              <div className='td' data-header-title='Vehicle Make / Model'>
                <p>{item.vehicle_model_or_make}</p>
              </div>
              <div className='td st' data-header-title='Year'>
                <p>{item.year}</p>
              </div>
              <div
                className='td exp_date'
                data-header-title='Vehicle License No.'
              >
                <p>
                  {item.vehicle_license === unDefined
                    ? ''
                    : item.vehicle_license}
                </p>
              </div>
            </div>,
          );
        }
        return optionsVeh;
      });
      if (count < 4) {
        for (i = count; i < 4; i++) {
          count++;
          optionsVeh.push(
            <div className='tr' key={'vehicle' + i}>
              <div className='td' data-header-title='Driver Name'>
                <p />
              </div>
              <div className='td' data-header-title='Vehicle Make / Model'>
                <p />
              </div>
              <div className='td st' data-header-title='Year'>
                <p />
              </div>
              <div
                className='td exp_date'
                data-header-title='Vehicle License No.'
              >
                <p />
              </div>
            </div>,
          );
        }
      }
      this.setState({ vehicleOptions: optionsVeh });
    }
  }

  generateVIPR() {
    if (this.state.crews.length > 0) {
      var options = [];
      var count = 0;
      this.state.crews.map((item, index) => {
        if (item.category === 'oncrew') {
          count++;
          options.push(
            <div className='tr middle_table' key={'manifest' + index}>
              <div
                className='print_hash_value td'
                data-header-title='Employee Name'
              >
                <p>
                  {count}. {item.first_name + ' ' + item.last_name}
                </p>
              </div>
              <div className='print_center gender td' data-header-title='M'>
                <p>{item.gender === 'Male' ? 'X' : ''}</p>
              </div>
              <div className='print_center gender td' data-header-title='F'>
                <p>{item.gender === 'Female' ? 'X' : ''}</p>
              </div>
              <div className='print_center td' data-header-title='Position'>
                <p>{item.incident_pos}</p>
              </div>
              <div
                className='print_center td'
                data-header-title='LAST NIGHT NOT SPENT ON FIRE ASSIGNMENT (DATE)'
              >
                {item.lnnsfa_date ? formatDate(item.lnnsfa_date) : ''}
              </div>
              <div
                className='print_center td'
                data-header-title='UNIQUE EMPLOYEE NUMBER (NO SSN)'
              >
                <p>{item.fire_id}</p>
              </div>
            </div>,
          );
        }
        return options;
      });
      if (count < 6) {
        for (var i = count; i < 6; i++) {
          count++;
          options.push(
            <div className='tr' key={'manifest' + i}>
              <div
                className='print_hash_value td'
                data-header-title='Employee Name'
              >
                <p>{count}. </p>
              </div>
              <div className='print_center gender td' data-header-title='M'>
                <p />
              </div>
              <div className='print_center gender td' data-header-title='F'>
                <p />
              </div>
              <div className='print_center td' data-header-title='Position'>
                <p></p>
              </div>
              <div
                className='print_center td'
                data-header-title='LAST NIGHT NOT SPENT ON FIRE ASSIGNMENT (DATE)'
              />
              <div
                className='print_center td'
                data-header-title='UNIQUE EMPLOYEE NUMBER (NO SSN)'
              >
                <p />
              </div>
            </div>,
          );
        }
      }
      this.setState({ crewOptions: options, isLoading: false });
    }
  }

  generateDCRM() {
    if (this.state.crews.length > 0) {
      var options = [],
        count = 0;
      this.state.crews.map((item, index) => {
        if (item.category === 'oncrew') {
          count++;
          options.push(
            <div className='middle_table tr' key={index}>
              <div
                className='td print_hash_value'
                data-header-title='Crew Member Name'
              >
                <p>
                  {count}. {item.first_name + ' ' + item.last_name}
                </p>
              </div>
              <div className='td print_center em_gender' data-header-title='M'>
                <p>{item.gender === 'Male' ? 'X' : ''}</p>
              </div>
              <div className='td print_center em_gender' data-header-title='F'>
                <p>{item.gender === 'Female' ? 'X' : ''}</p>
              </div>
              <div
                className='td print_center em_crew_mem_no'
                data-header-title='Employee Id Number'
              >
                <p>{item.fire_id}</p>
              </div>
              <div
                className='print_center td'
                data-header-title='Project Position'
              >
                <p>{item.incident_pos}</p>
              </div>
              <div
                className='td em_phone print_hash_value'
                data-header-title='Phone Number'
              >
                <p>{this.formatPhoneNumber(item.phone)}</p>
              </div>
            </div>,
          );
        }
        return options;
      });

      if (count < 20) {
        for (var i = count; i < 20; i++) {
          count++;
          options.push(
            <div className='middle_table tr' key={'ifca' + i}>
              <div
                className='td print_hash_value'
                data-header-title='Crew Member Name'
              >
                <p>{count}. </p>
              </div>
              <div className='td print_center em_gender' data-header-title='M'>
                <p />
              </div>
              <div className='td print_center em_gender' data-header-title='F'>
                <p />
              </div>
              <div
                className='td print_center em_crew_mem_no'
                data-header-title='Employee Id Number'
              >
                <p />
              </div>
              <div
                className='td print_center'
                data-header-title='Project Position'
              >
                <p />
              </div>
              <div
                className='td em_phone print_hash_value'
                data-header-title='Phone Number'
              >
                <p></p>
              </div>
            </div>,
          );
        }
      }
      this.setState({ crewOptions: options, isLoading: false });
    }

    var optionsVeh = [];
    count = 0;
    if (this.state.vehicles.length > 0) {
      this.state.vehicles.map((item, index) => {
        if (item.category === 'selected') {
          count++;
          optionsVeh.push(
            <div className='tr' key={index}>
              <div className='td' data-header-title='Driver Name'>
                <p>{item.first_name + ' ' + item.last_name}</p>
              </div>
              <div className='td' data-header-title='License Number/State'>
                <p>{item.drivers_license}</p>
              </div>
              <div
                className='td DLIssued'
                data-header-title='Drivers License Issued State'
              >
                <p>{item.DLState}</p>
              </div>
              <div className='td mdate' data-header-title='MSPA Exp. Date'>
                <p>{formatDate(item.mspa_exp_date)}</p>
              </div>
              <div className='td' data-header-title='Vehicle License No.'>
                <p>
                  {item.vehicle_license === unDefined
                    ? ''
                    : item.vehicle_license}
                </p>
              </div>
            </div>,
          );
        }
        return optionsVeh;
      });
    }
    if (count < 4) {
      // var tot = count;
      for (i = count; i < 4; i++) {
        count++;
        optionsVeh.push(
          <div className='tr' key={'veh' + i}>
            <div className='td' data-header-title='Driver Name'>
              <p />
            </div>
            <div className='td' data-header-title='License Number/State'>
              <p />
            </div>
            <div
              className='td DLIssued'
              data-header-title='Drivers License Issued State'
            >
              <p />
            </div>
            <div className='td mdate' data-header-title='MSPA Exp. Date'>
              <p />
            </div>
            <div className='td' data-header-title='Vehicle License No.'>
              <p />
            </div>
          </div>,
        );
      }
    }
    this.setState({ vehicleOptions: optionsVeh });
  }

  generatePM() {
    if (this.state.crews.length > 0) {
      var options = [],
        count = 0;
      this.state.crews.map((item, index) => {
        if (item.category === 'oncrew') {
          count++;
          options.push(
            <div className='middle_table tr' key={index}>
              <div
                className='td print_hash_value'
                data-header-title='Crew Member Name'
              >
                <p>
                  {count}. {item.first_name + ' ' + item.last_name}
                </p>
              </div>
              <div className='td print_center em_gender' data-header-title='M'>
                <p>{item.gender === 'Male' ? 'X' : ''}</p>
              </div>
              <div className='td print_center em_gender' data-header-title='F'>
                <p>{item.gender === 'Female' ? 'X' : ''}</p>
              </div>
              <div
                className='td print_center em_crew_mem_no'
                data-header-title='Employee Id Number'
              >
                <p>{item.fire_id}</p>
              </div>
              <div
                className='td print_center'
                data-header-title='Project Position'
              >
                {item.incident_pos}
              </div>
              <div
                className='td em_phone print_hash_value'
                data-header-title='Phone Number'
              >
                <p>{this.formatPhoneNumber(item.phone)}</p>
              </div>
            </div>,
          );
        }
        return options;
      });

      if (count < 20) {
        for (var i = count; i < 20; i++) {
          count++;
          options.push(
            <div className='middle_table tr' key={'ifca' + i}>
              <div
                className='td print_hash_value'
                data-header-title='Crew Member Name'
              >
                <p>{count}. </p>
              </div>
              <div className='td print_center em_gender' data-header-title='M'>
                <p />
              </div>
              <div className='td print_center em_gender' data-header-title='F'>
                <p />
              </div>
              <div
                className='td print_center em_crew_mem_no'
                data-header-title='Employee Id Number'
              >
                <p />
              </div>
              <div
                className='td print_center'
                data-header-title='Project Position'
              >
                <p />
              </div>
              <div
                className='td em_phone print_hash_value'
                data-header-title='Phone Number'
              >
                <p></p>
              </div>
            </div>,
          );
        }
      }
      this.setState({ crewOptions: options, isLoading: false });
    }

    if (this.state.vehicles.length > 0) {
      var optionsVeh = [];
      count = 0;
      this.state.vehicles.map((item, index) => {
        if (item.category === 'selected') {
          count++;
          optionsVeh.push(
            <div className='tr' key={index}>
              <div className='td' data-header-title='Driver Name'>
                <p>{item.first_name + ' ' + item.last_name}</p>
              </div>
              <div className='td' data-header-title='License Number/State'>
                <p>{item.drivers_license}</p>
              </div>
              <div
                className='td DLIssued'
                data-header-title='Drivers License Issued State'
              >
                <p>{item.DLState}</p>
              </div>
              <div className='td mdate' data-header-title='MSPA Exp. Date'>
                <p>{formatDate(item.mspa_exp_date)}</p>
              </div>
              <div className='td' data-header-title='Vehicle License No.'>
                <p>
                  {item.vehicle_license === unDefined
                    ? ''
                    : item.vehicle_license}
                </p>
              </div>
            </div>,
          );
        }
        return optionsVeh;
      });

      if (count < 4) {
        // var tot = count;
        for (i = count; i < 4; i++) {
          count++;
          optionsVeh.push(
            <div className='tr' key={'veh' + i}>
              <div className='td' data-header-title='Driver Name'>
                <p />
              </div>
              <div className='td' data-header-title='License Number/State'>
                <p />
              </div>
              <div
                className='td DLIssued'
                data-header-title='Drivers License Issued State'
              >
                <p />
              </div>
              <div className='td mdate' data-header-title='MSPA Exp. Date'>
                <p />
              </div>
              <div className='td' data-header-title='Vehicle License No.'>
                <p />
              </div>
            </div>,
          );
        }
      }
      this.setState({ vehicleOptions: optionsVeh });
    }
  }

  componentWillReceiveProps(nextProps) {
    // Handle versionData changes when switching versions
    if (
      nextProps.versionData &&
      nextProps.versionData !== this.props.versionData
    ) {
      this.loadVersionData(nextProps.versionData);
      return;
    }

    const { superintendent, manifest, crews, vehicles } = nextProps;
    if (superintendent.list) {
      const { data } = superintendent.list;
      if (data.length > 0) {
        this.setState({ superintendent: data[0] });
      }
    }
    if (manifest) {
      if (manifest.print) {
        var pdf = manifest.print.data;
        // window.open(pdf, '_blank');
        var windowReference = window.open();

        windowReference.location = pdf;

        this.props.details(this.props.resource_id);
      }
    }

    if (manifest.list) {
      if (manifest.list.success) {
        const form = manifest.list.data;
        var state = {};

        if (form.added_date) {
          state['added_date'] = form.added_date;
        }

        if (form.base_manifest_id) {
          state['manifestType'] = form.base_manifest_id;
        }
        if (form.eff_end_date) {
          state['mend'] = moment(form.eff_end_date).format('MM/DD/YY');
        }
        if (form.eff_start_date) {
          state['mstart'] = moment(form.eff_start_date).format('MM/DD/YY');
        }

        if (Object.keys(state).length) {
          this.setState(state);
        }

        this.setState({ form: form }, function () {
          // this.setState({ manifestType:form.base_manifest_id },function(){
          if (this.state.manifestType === MANIFEST_TYPE.IFCA_Manifest) {
            this.generateIFCA();
          }
          if (
            this.state.manifestType === MANIFEST_TYPE.NCC ||
            this.state.manifestType === MANIFEST_TYPE.TYPE_2
          ) {
            this.generateNCC();
          }
          if (this.state.manifestType === MANIFEST_TYPE.VIPR) {
            this.generateVIPR();
          }
          if (this.state.manifestType === MANIFEST_TYPE.DCRM) {
            this.generateDCRM();
          }
          if (this.state.manifestType === MANIFEST_TYPE.PROJECT_MANIFEST) {
            this.generatePM();
          }
          if (this.state.manifestType === MANIFEST_TYPE.ODF) {
            this.generateODF();
          }
        });
      }
    }
    if (crews.list) {
      const { data } = crews.list;
      if (data.length > 0) {
        this.setState({ crews: data }, function () {
          if (this.state.manifestType === MANIFEST_TYPE.IFCA_Manifest) {
            this.generateIFCA();
          }
          if (
            this.state.manifestType === MANIFEST_TYPE.NCC ||
            this.state.manifestType === MANIFEST_TYPE.TYPE_2
          ) {
            this.generateNCC();
          }
          if (this.state.manifestType === MANIFEST_TYPE.VIPR) {
            this.generateVIPR();
          }
          if (this.state.manifestType === MANIFEST_TYPE.DCRM) {
            this.generateDCRM();
          }
          if (this.state.manifestType === MANIFEST_TYPE.PROJECT_MANIFEST) {
            this.generatePM();
          }
          if (this.state.manifestType === MANIFEST_TYPE.ODF) {
            this.generateODF();
          }
        });
      }
    }
    if (vehicles.vehicleList) {
      const { data } = vehicles.vehicleList;
      if (data.length > 0) {
        this.setState({ vehicles: data }, function () {
          if (this.state.manifestType === MANIFEST_TYPE.IFCA_Manifest) {
            this.generateIFCA();
          }
          if (
            this.state.manifestType === MANIFEST_TYPE.NCC ||
            this.state.manifestType === MANIFEST_TYPE.TYPE_2
          ) {
            this.generateNCC();
          }
          if (this.state.manifestType === MANIFEST_TYPE.VIPR) {
            this.generateVIPR();
          }
          if (this.state.manifestType === MANIFEST_TYPE.DCRM) {
            this.generateDCRM();
          }
          if (this.state.manifestType === MANIFEST_TYPE.PROJECT_MANIFEST) {
            this.generatePM();
          }
          if (this.state.manifestType === MANIFEST_TYPE.ODF) {
            this.generateODF();
          }
        });
      }
    }
  }

  render() {
    // const { superintendent,manifest,crews,vehicles } = this.props
    // const { pageNumber, numPages } = this.state;

    let yourDate = new Date();

    if (this.state.added_date) {
      yourDate = new Date(this.state.added_date);
    }

    var curDate = moment(yourDate).format('MM/DD/YY');

    const form = this.state.form;
    var fname, lname, sup_name;
    if (this.state.superintendent) {
      fname = this.state.superintendent.first_name
        ? this.state.superintendent.first_name
        : '';
      lname = this.state.superintendent.last_name
        ? this.state.superintendent.last_name
        : '';
      if (fname !== '' && lname !== '') {
        sup_name = fname + ' ' + lname;
      } else {
        sup_name = '-';
      }
    }

    return this.state.isLoading ? (
      <div className='inner_container col-lg-12'>
        <center id='feedLoader' style={{ display: 'block' }}>
          <img
            alt='Loader'
            src={require('../assets/images/loader.gif').default}
          />
        </center>
      </div>
    ) : (
      <div className='content_div view_manifest_page inner_container'>
        {(this.state.manifestType === MANIFEST_TYPE.IFCA_Manifest ||
          this.state.manifestType === MANIFEST_TYPE.ODF) && (
          <Ifca
            curDate={curDate}
            form={form}
            sup_name={sup_name}
            sphone={this.state.superintendent?.phone || ''}
            crewOptions={this.state.crewOptions}
            vehicleOptions={this.state.vehicleOptions}
            formatDate={formatDate}
            manifestType={this.state.manifestType}
            viewOnly={true}
            handleOnViewResourceOrderForm={this.handleViewResourceOrderForm.bind(
              this,
            )}
            printManifest={this.printManifest.bind(this)}
          />
        )}

        {/* -------------------------------------------------------------------------------------------------------------------- */}

        {(this.state.manifestType === MANIFEST_TYPE.NCC ||
          this.state.manifestType === MANIFEST_TYPE.TYPE_2) && (
          <Ncc
            curDate={curDate}
            form={form}
            sup_name={sup_name}
            sphone={this.state.superintendent?.phone || ''}
            crewOptions={this.state.crewOptions}
            vehicleOptions={this.state.vehicleOptions}
            formatDate={formatDate}
            manifestType={this.state.manifestType}
            viewOnly={true}
            handleOnViewResourceOrderForm={this.handleViewResourceOrderForm.bind(
              this,
            )}
            printManifest={this.printManifest.bind(this)}
          />
        )}

        {/* -------------------------------------------------------------------------------------------------------------------- */}

        {this.state.manifestType === MANIFEST_TYPE.VIPR && (
          <Vipr
            eff_start_date={
              this.state.mstart ? moment(this.state.mstart) : null
            }
            eff_end_date={this.state.mend ? moment(this.state.mend) : null}
            curDate={curDate}
            form={form}
            crewOptions={this.state.crewOptions}
            formatDate={formatDate}
            manifestType={this.state.manifestType}
            viewOnly={true}
            handleOnViewResourceOrderForm={this.handleViewResourceOrderForm.bind(
              this,
            )}
            printManifest={this.printManifest.bind(this)}
            resource_id={this.props.resource_id}
          />
        )}

        {/* -------------------------------------------------------------------------------------------------------------------- */}

        {this.state.manifestType === MANIFEST_TYPE.DCRM && (
          <Dcrm
            sup_name={sup_name}
            sphone={this.state.superintendent?.phone || ''}
            curDate={curDate}
            form={form}
            crewOptions={this.state.crewOptions}
            vehicleOptions={this.state.vehicleOptions}
            formatDate={formatDate}
            manifestType={this.state.manifestType}
            viewOnly={true}
            handleOnViewResourceOrderForm={this.handleViewResourceOrderForm.bind(
              this,
            )}
            printManifest={this.printManifest.bind(this)}
          />
        )}

        {/* -------------------------------------------------------------------------------------------------------------------- */}

        {this.state.manifestType === MANIFEST_TYPE.PROJECT_MANIFEST && (
          <Project
            sup_name={sup_name}
            sphone={this.state.superintendent?.phone || ''}
            curDate={curDate}
            form={form}
            crewOptions={this.state.crewOptions}
            vehicleOptions={this.state.vehicleOptions}
            formatDate={formatDate}
            viewOnly={true}
            handleOnViewResourceOrderForm={this.handleViewResourceOrderForm.bind(
              this,
            )}
            printManifest={this.printManifest.bind(this)}
          />
        )}
      </div>
    );
  }
}

ViewManifest.propTypes = {
  dispatch: PropTypes.func.isRequired,
  crews: PropTypes.array,
  vehicles: PropTypes.array,
  manifestType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  manifest_id: PropTypes.string,
  superintendent: PropTypes.object.isRequired,
  manifest: PropTypes.object.isRequired,
  resource_id: PropTypes.any,
  manifest_version_id: PropTypes.any,
};

function mapStateToProps(state) {
  const { superintendent, manifest, crews, vehicles } = state;
  return {
    superintendent,
    manifest,
    crews,
    vehicles,
  };
}

const connectedResourcePage = connect(mapStateToProps)(
  withRouter(ViewManifest),
);
export { connectedResourcePage as ViewManifest };

ViewManifest.propTypes = {
  dispatch: PropTypes.func.isRequired,
  manifest_id: PropTypes.any,
  resource_id: PropTypes.any,
  manifest_version_id: PropTypes.any,
  manifestType: PropTypes.any,
};
